exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".po-form .form-group{margin-bottom:0}.po-form .help-block{font-size:13px}.po-form .actions-label{font-size:14px;margin-right:10px}.po-form .actions-select{width:200px}.po-form .po-form-label{margin-bottom:5px;font-size:14px}", ""]);

// exports
